import { render, staticRenderFns } from "./ClientAgreements.vue?vue&type=template&id=277ee148&scoped=true&"
import script from "./ClientAgreements.vue?vue&type=script&lang=js&"
export * from "./ClientAgreements.vue?vue&type=script&lang=js&"
import style0 from "./ClientAgreements.vue?vue&type=style&index=0&id=277ee148&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277ee148",
  null
  
)

export default component.exports